<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <div class="container" style="padding: 0px">
        <div class="col-sm-12 col-lg-8 m-auto">
          <el-form
            :model="formdata"
            :rules="rules"
            ref="formdata"
            label-width="200px"
            :label-position="labelPosition"
            size="medium"
            status-icon
            @submit.native.prevent
            style="
              border: 1px solid #e2e2e2;
              border-radius: 5px;
              background-color: #fff;
              padding: 20px;
            "
          >
            <h3 class="text-center text-info pt-4">Edit Item</h3>
            <div class="file-upload col-12 col-md-6" style="margin-top: 25px">
              <div class="image-upload-wrap" style="height: 100px">
                <input
                  class="file-upload-input"
                  type="file"
                  @change="fileSelect1"
                  accept=".jpg, .jpeg"
                />
                <div class="drag-text">
                  <h6 class="pt-3">Add main image</h6>
                  <h6></h6>
                </div>
              </div>
              <div class="mx-auto text-center">
                <img
                  class="file-upload-image"
                  :src="formdata.imageUrl"
                  alt="your image"
                />
              </div>
            </div>

            <div style="height: auto" class="mt-3 mb-4">
              <div class="file-upload">
                <div
                  class="image-upload-wrap col-12 col-md-6 m-auto"
                  style="height: 100px"
                >
                  <input
                    class="file-upload-input"
                    type="file"
                    multiple
                    @change="otherIMG"
                    accept=".jpg, .jpeg"
                  />
                  <div class="drag-text">
                    <h6 class="pt-3 pb-1">Add other images</h6>
                    <p>(maximum 4 images)</p>
                  </div>
                </div>
                <div class="row">
                  <div
                    v-for="(file, i) in imgfiles"
                    :key="i"
                    class="justify-item-center col-12 col-sm-6 col-md-3"
                  >
                    <div>
                      <img
                        class="file-upload-image"
                        style="margin-right: 0px"
                        :src="file"
                        alt="your image"
                      />
                      <div class="image-title-wrap mt-2">
                        <el-button
                          type="danger"
                          size="small"
                          @click="removeimg(i)"
                          >Remove Image</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-form-item label="Product Name" prop="name">
              <el-input
                v-model="formdata.name"
                clearable
                style="width: 220px"
              ></el-input>
            </el-form-item>

            <el-form-item label="Barcode/SKU" prop="barcode">
              <el-input
                v-model="formdata.barcode"
                clearable
                @change="checkBarcode"
                style="width: 220px"
              ></el-input>
            </el-form-item>

            <el-form-item label="Quantity" prop="quantity">
              <el-input
                v-model.number="formdata.quantity"
                type="number"
                clearable
                style="width: 220px"
                :min="1"
              ></el-input>
            </el-form-item>

            <el-form-item label="Main Price" prop="price">
              <el-input
                v-model.number="formdata.price"
                class="input-with-select"
                style="width: 220px"
                clearable
              >
                <template slot="prepend">RS</template>
              </el-input>
            </el-form-item>

            <el-form-item label="Price List">
              <el-select
                v-model="formdata.priceList"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Prices"
              >
                <el-option
                  v-for="item in formdata.priceList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Product Variations">
              <el-select
                v-model="formdata.variations"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Variations"
              >
                <el-option
                  v-for="item in formdata.variations"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Discount" prop="dis">
              <el-input
                placeholder="Discount"
                v-model.number="formdata.dis"
                style="width: 220px"
              >
                <template slot="append"><i class="fa fa-percent"></i></template>
              </el-input>
            </el-form-item>

            <el-form-item label="Category" prop="category">
              <el-select v-model="category" placeholder="Category">
                <el-option :value="this.$route.params.cat">{{
                  category
                }}</el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Brand" prop="brand">
              <el-select v-model="subcategory" placeholder="Brand">
                <el-option
                  v-for="(subcat, key) in subcategories"
                  :key="key"
                  :value="key"
                  >{{ key }}</el-option
                >
              </el-select>
            </el-form-item>

            <el-form-item label="Model" prop="model">
              <el-input
                placeholder="Model"
                v-model="formdata.model"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
              </el-input>
            </el-form-item>

            <!-- <el-form-item label="Sub Category" prop="subcategory">
    <el-select v-model="subcategory" placeholder="Sub Category">
       <el-option v-for="(subcat, key) in subcategories" :key="key" :value="key">{{key}}</el-option>
    </el-select>
  </el-form-item> -->
            <el-form-item label="Main Color" prop="color">
              <el-input
                v-model="formdata.color"
                placeholder="Color"
                style="width: 220px"
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item label="Other Colors">
              <el-select
                v-model="formdata.colors"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Enter Other Colors"
              >
                <el-option
                  v-for="item in formdata.colors"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="CPU" prop="cpu">
              <el-input
                placeholder="CPU"
                v-model="formdata.cpu"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="CPU Generation"
              prop="cpugen"
              v-if="shopcat == 'Computers & Laptops'"
            >
              <el-input
                placeholder="CPU Generation"
                v-model="formdata.cpugen"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="OS" prop="os">
              <el-input
                placeholder="OS"
                v-model="formdata.os"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
              </el-input>
            </el-form-item>

            <el-form-item
              label="Hard Drive"
              prop="hard"
              v-if="shopcat == 'Computers & Laptops'"
            >
              <el-input
                placeholder="Hard Drive"
                v-model="formdata.hard"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">GB</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Storage/ROM"
              prop="storage"
              v-if="shopcat == 'Mobiles & Tablets'"
            >
              <el-input
                placeholder="Storage/ROM"
                v-model="formdata.storage"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">GB</template>
              </el-input>
            </el-form-item>

            <el-form-item label="RAM" prop="ram">
              <el-input
                placeholder="RAM"
                v-model="formdata.ram"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">GB</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Graphics"
              prop="graphics"
              v-if="shopcat == 'Computers & Laptops'"
            >
              <el-input
                placeholder="Graphics"
                v-model="formdata.graphics"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">GB</template>
              </el-input>
            </el-form-item>

            <el-form-item label="Screen Size" prop="screen">
              <el-input
                placeholder="Screen Size"
                v-model="formdata.screen"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">inches</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Rear Camera"
              prop="rearcamera"
              v-if="shopcat == 'Mobiles & Tablets'"
            >
              <el-input
                placeholder="Rear Camera"
                v-model="formdata.rearcamera"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">MP</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Front Camera"
              prop="frontcamera"
              v-if="shopcat == 'Mobiles & Tablets'"
            >
              <el-input
                placeholder="Front Camera"
                v-model="formdata.frontcamera"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">MP</template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Battery"
              prop="battery"
              v-if="shopcat == 'Mobiles & Tablets'"
            >
              <el-input
                placeholder="Battery"
                v-model="formdata.battery"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">mAh</template>
              </el-input>
            </el-form-item>

            <el-form-item label="Weight" prop="weight">
              <el-input
                placeholder="Weight"
                v-model="formdata.weight"
                style="width: 220px"
                class="input-with-select"
                type="text"
              >
                <template slot="append">g</template>
              </el-input>
            </el-form-item>
            <el-form-item label="Condition" prop="cond">
              <el-select v-model="formdata.cond" placeholder="Condition">
                <el-option value="new">New</el-option>
                <el-option value="used">Used</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Item Type" prop="type">
              <el-select v-model="formdata.type" placeholder="Item Type">
                <el-option value="none">None</el-option>
                <el-option value="latest">Latest Item</el-option>
                <el-option value="bestselling">Best Selling Item</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Warranty" prop="warranty">
              <el-select
                filterable
                allow-create
                v-model="formdata.warranty"
                placeholder="Warranty"
                style="width: 220px"
                clearable
              >
                <el-option value="No Warranty">No Warranty</el-option>
                <el-option value="1 Months Warranty"
                  >1 Months Warranty</el-option
                >
                <el-option value="3 Months Warranty"
                  >3 Months Warranty</el-option
                >
                <el-option value="6 Months Warranty"
                  >6 Months Warranty</el-option
                >
                <el-option value="1 Year Warranty">1 Year Warranty</el-option>
                <el-option value="2 Year Warranty">2 Year Warranty</el-option>
                <el-option value="3 Year Warranty">3 Year Warranty</el-option>
                <el-option value="4 Year Warranty">4 Year Warranty</el-option>
                <el-option value="5 Year Warranty">5 Year Warranty</el-option>
                <el-option value="10 Year Warranty">10 Year Warranty</el-option>
                <el-option value="Lifetime Warranty"
                  >Lifetime Warranty</el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item label="Product Description" prop="desc">
              <el-input
                type="textarea"
                v-model="formdata.desc"
                maxlength="1000"
                :autosize="{ minRows: 2, maxRows: 4 }"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="updateForm('formdata')"
                >Update</el-button
              >
              <el-button type="danger" @click="goback()">Go Back</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCompressor from "image-compressor.js";
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import mobiles from "../../data/mobiles";
import ClothingAccessories from "../../data/ClothingAccessories";
export default {
  name: "editmobiles",
  data() {
    var checkprice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("Price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      subcategory: "",
      shoptype: "",
      shopcat: "",
      tags: [],
      shops: [],
      options: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      dis: "",
      price: "",

      loading: false,
      loading1: false,
      changed: true,

      formdata: {
        name: "",
        price: "",
        barcode: "",
        quantity: 0,
        priceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: "",
        disprice: "",
        brand: "",
        color: "",
        cond: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,

        model: "",
        cpu: "",
        cpugen: "",
        hard: "",
        storage: "",
        ram: "",
        graphics: "",
        screen: "",
        rearcamera: "",
        frontcamera: "",
        os: "",
        battery: "",
        weight: "",
      },

      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
          {
            min: 3,
            max: 100,
            message: "Length should be 3 to 100",
            trigger: "blur",
          },
        ],
        barcode: [
          { required: true, message: "Please input barcode", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "Please input quantity", trigger: "blur" },
          {
            min: 1,
            type: "number",
            message: "Minimum quantity is 0",
            trigger: "blur",
          },
        ],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [
          { message: "Please select the brand", trigger: "change" },
        ],
        model: [
          { required: true, message: "Please input model", trigger: "blur" },
        ],
        cond: [
          {
            required: true,
            message: "Please select condition",
            trigger: "change",
          },
        ],
        desc: [{ message: "Please input description", trigger: "blur" }],
      },
    };
  },

  methods: {
    pickFile() {
      this.$refs.fileInput.click();
    },
    goback() {
      this.$router.push({
        name: "allProducts",
        params: { cat: this.$route.params.cat },
      });
    },
    fileSelect1(event) {
      //console.log('event is', event)
      if (event.target.files.length > 0) {
        const files = event.target.files;
        let filename = files[0].name;
        if (
          files[0].type == "image/png" ||
          files[0].type == "image/gif" ||
          files[0].type == "image/svg+xml" ||
          files[0].type == "image/tiff"
        ) {
          alert(
            "File " +
              files[0].name +
              " is not type of jpeg or jpg!. You cannot upload other types of images."
          );
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            this.visible = "none";
            this.formdata.imageUrl = reader.result;
            this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          const imageCompressor = new ImageCompressor();
          imageCompressor
            .compress(files[0], { quality: 0.8, width: 720, height: 1340 })
            .then((result) => {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                const imageCompressor = new ImageCompressor();
                imageCompressor
                  .compress(result, { quality: 0.6 })
                  .then((result) => {
                    const fileReader = new FileReader();

                    // This fires after the blob has been read/loaded.
                    fileReader.addEventListener("load", () => {
                      this.formdata.imageUrl = fileReader.result;

                      //console.log('image is',this.formdata.imageUrl)
                    });

                    // Start reading the blob as text.
                    fileReader.readAsDataURL(result);

                    ////console.log(filename)
                    //console.log(result.size)
                    //console.log('image is',result)
                  });
              } else {
                var fileReader = new FileReader();
                fileReader.addEventListener("load", () => {
                  this.formdata.imageUrl = fileReader.result;

                  //console.log('else image is',this.formdata.imageUrl)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            })

            .catch((err) => {
              // Handle the error
              //console.log("error is" + err)
            });
        }
      }
    },

    otherIMG(event) {
      var files = event.target.files;
      //console.log('files are', files)
      //  //console.log('imgfiles.length are', this.imgfiles.length)
      if (
        files.length > this.maxFiles ||
        this.imgfiles.length >= this.maxFiles ||
        files.length + this.imgfiles.length > this.maxFiles
      ) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (
            files[0].type == "image/png" ||
            files[0].type == "image/gif" ||
            files[0].type == "image/svg+xml" ||
            files[0].type == "image/tiff"
          ) {
            alert(
              "File " +
                files[0].name +
                " is not type of jpeg or jpg!. You cannot upload other types of images."
            );
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", () => {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              this.visible = "none";
              // this.logoimg = reader.result
              this.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            const imageCompressor = new ImageCompressor();
            imageCompressor
              .compress(files[i], { quality: 0.6, width: 720, height: 1340 })
              .then((result) => {
                // Handle the compressed image file.
                if (result.size >= 1000000) {
                  const imageCompressor = new ImageCompressor();
                  imageCompressor
                    .compress(result, { quality: 0.5 })
                    .then((result) => {
                      const fileReader = new FileReader();

                      // This fires after the blob has been read/loaded.
                      fileReader.addEventListener("load", () => {
                        this.imgfiles.push(fileReader.result);
                        var otherimg = fileReader.result;
                        this.otherimgs.push(otherimg);
                        //console.log('image is',this.otherimgs)
                      });

                      // Start reading the blob as text.
                      fileReader.readAsDataURL(result);

                      ////console.log(filename)
                      //console.log(result.size)
                      //console.log('image is',result)
                    });
                } else {
                  //  const reader = new FileReader();

                  //     // This fires after the blob has been read/loaded.
                  //     reader.addEventListener('loadend', (e) => {
                  //       this.image2 = e.srcElement.result;
                  //      //console.log('else image is',this.image2)
                  //     });

                  //     // Start reading the blob as text.
                  //     reader.readAsText(result);
                  var fileReader = new FileReader();
                  fileReader.addEventListener("load", () => {
                    this.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    this.otherimgs.push(otherimg);
                    //console.log('else image is',this.otherimgs)
                  });
                  fileReader.readAsDataURL(result);
                  ////console.log(filename)
                  //console.log('else',result.size)
                  //console.log('ekse image is',result)
                }
              })

              .catch((err) => {
                // Handle the error
                //console.log("error is" + err)
              });
          }
        }
      }
    },

    removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },

    checkBarcode() {
      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase
          .collection("products")
          .where("barcode", "==", this.formdata.barcode)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (this.$route.params.product_id !== doc.id) {
                const barcode = this.formdata.barcode;
                this.formdata.barcode = "";
                return this.$notify.error({
                  title: "Error",
                  message: "Barcode " + barcode + " is already used",
                  type: "error",
                });
              }
            });
          })
          .catch((error) => alert(error.message));
      }
    },

    updateForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          this.backToTop();
          this.loading = true;
          this.changed = false;
          var scope = this;
          if (
            this.formdata.dis != this.dis ||
            this.formdata.price != this.price
          ) {
            this.formdata.disprice = this.formdata.price;
            this.formdata.price =
              this.formdata.price -
              (this.formdata.price * this.formdata.dis) / 100;
          } else {
            this.formdata.disprice = this.formdata.price;
          }
          this.$store.state.secondaryDatabase
            .collection("products")
            .doc(this.$route.params.product_id)
            .update({
              name: this.formdata.name,
              cat: this.category,
              subcat: this.subcategory,
              price: this.formdata.price,
              disprice: this.formdata.disprice,
              barcode: this.formdata.barcode,
              quantity: this.formdata.quantity,
              priceList: this.formdata.priceList.map((price) => +price),
              variations: this.formdata.variations,
              colors: this.formdata.colors,
              expireDate: this.formdata.expireDate ? new Date(this.formdata.expireDate) : "",
              dis: this.formdata.dis,
              brand: this.formdata.brand,
              color: this.formdata.color,
              cond: this.formdata.cond,
              type: this.formdata.type,
              war: this.formdata.warranty,
              desc: this.formdata.desc,
              img: this.formdata.imageUrl,
              otherimgs: this.otherimgs,

              details: {
                model: this.formdata.model,
                cpu: this.formdata.cpu,
                storage: this.formdata.storage,
                ram: this.formdata.ram,
                screen: this.formdata.screen,
                rearcamera: this.formdata.rearcamera,
                frontcamera: this.formdata.frontcamera,
                os: this.formdata.os,
                battery: this.formdata.battery,
                weight: this.formdata.weight,
                cpugeneration: this.formdata.cpugen,
                hard: this.formdata.hard,
                graphics: this.formdata.graphics,
              },
            })
            .then(() => {
              var newitems = this.$store.state.items[
                this.$route.params.cat
              ].filter((item) => {
                //console.log('filfkkk')
                return item.id !== this.$route.params.product_id;
              });
              newitems.unshift({
                id: this.$route.params.product_id,
                name: this.formdata.name,
                barcode: this.formdata.barcode,
                quantity: this.formdata.quantity,
                category: this.category,
                subcategory: this.subcategory,
                price: this.formdata.price,
                brand: this.formdata.brand,
                //make sure to use same property name used in store.js getItems fun
              });
              this.$store.state.items[this.$route.params.cat] = newitems;
              this.$router.push({
                name: "allProducts",
                params: { cat: this.$route.params.cat },
              });
              //console.log('prd updated')
            });
        } else {
          alert("error update");
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "slow",
        "swing"
      );
    },
  },

  created() {
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
    }
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            categories: doc.data().categories,
            shoptype: doc.data().shoptype,
            shopcat: doc.data().cat,
          };
          this.shops.push(data);
          this.shopcat = this.shops[0].shopcat;
          this.shoptype = this.shops[0].shoptype;
          this.category = this.$route.params.cat;
          this.subcategories = this.shops[0].categories[this.$route.params.cat];
          //console.log('this.subcategories is', this.subcategories)
        });
      });

    //console.log(this.$route.params.product_id)
    this.$store.state.secondaryDatabase
      .collection("products")
      .doc(this.$route.params.product_id)
      .get()
      .then((doc) => {
        (this.formdata.name = doc.data().name),
          (this.subcategory = doc.data().subcat),
          (this.formdata.brand = doc.data().brand),
          (this.formdata.price = doc.data().disprice),
          (this.formdata.dis = doc.data().dis),
          (this.dis = doc.data().dis),
          (this.price = doc.data().disprice),
          (this.formdata.barcode = doc.data().barcode),
          (this.formdata.quantity = doc.data().quantity);
        this.formdata.priceList = doc.data().priceList;
        this.formdata.variations = doc.data().variations;
        this.formdata.colors = doc.data().colors;
        this.formdata.expireDate = doc.data().expireDate ? doc.data().expireDate.toDate().toLocaleString() : "";

        (this.formdata.color = doc.data().color),
          (this.formdata.cond = doc.data().cond),
          (this.formdata.type = doc.data().type);
        (this.formdata.warranty = doc.data().war),
          (this.formdata.desc = doc.data().desc),
          (this.formdata.imageUrl = doc.data().img);
        (this.imgfiles = doc.data().otherimgs),
          (this.otherimgs = doc.data().otherimgs),
          (this.formdata.model = doc.data().details.model),
          (this.formdata.cpu = doc.data().details.cpu),
          (this.formdata.storage = doc.data().details.storage),
          (this.formdata.ram = doc.data().details.ram),
          (this.formdata.screen = doc.data().details.screen),
          (this.formdata.rearcamera = doc.data().details.rearcamera),
          (this.formdata.frontcamera = doc.data().details.frontcamera),
          (this.formdata.os = doc.data().details.os),
          (this.formdata.battery = doc.data().details.battery),
          (this.formdata.weight = doc.data().details.weight),
          (this.formdata.cpugen = doc.data().details.cpugeneration),
          (this.formdata.hard = doc.data().details.hard),
          (this.formdata.graphics = doc.data().details.graphics);

        this.loading1 = false;
        this.changed = true;
      });
  },
  mounted() {},
};
</script>

<style scoped>
@import url("~@/assets/admin/css/imgupload.css");
@import url("~@/assets/admin/css/admin-loader.css");
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/EditMobiles.vue